import { render, staticRenderFns } from "./DeliveryAlert.vue?vue&type=template&id=565f2164&"
import script from "./DeliveryAlert.vue?vue&type=script&lang=js&"
export * from "./DeliveryAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports